import { ref, computed, nextTick } from "vue";
import { useStore } from "vuex";

/**
 * Autosave to datastore and sync lab attempt updates from the lab area.
 * @param {object} [options]
 * @param {import('vuex').Store} [options.store]
 * @param {() => ((data: object) => Promise<unknown>) | undefined} [options.getUpdateEntry] Mixin `updateEntry` from ActivityView (after mount).
 */
export function useLabPersistence(options = {}) {
  const store = options.store ?? useStore();
  const getUpdateEntry = options.getUpdateEntry;

  const savingProgress = ref(false);
  const useDatastore = computed(() => store.getters.useDatastore);
  const mapToDatastore = computed(() => store.getters.mapToDatastore);

  function saveProgress() {
    if (!useDatastore.value) return;
    const updateEntry = getUpdateEntry?.();
    if (!updateEntry) {
      return;
    }
    savingProgress.value = true;
    updateEntry(mapToDatastore.value).then(() => {
      nextTick(() => {
        savingProgress.value = false;
      });
    });
  }

  function handleLabDataUpdate(data) {
    const attempt = store.getters.getCurrentLabAttempt;
    if (attempt) {
      store.dispatch("updateLabAttempt", {
        attemptId: attempt.attemptId,
        updates: data
      });
      saveProgress();
    }
  }

  function toggleSimpleUI() {
    store.dispatch("setShowSimpleUI", !store.getters.showSimpleUI);
    saveProgress();
  }

  return {
    savingProgress,
    saveProgress,
    handleLabDataUpdate,
    toggleSimpleUI
  };
}
